import type { DtsInboundSftpDto } from '@dhl/mdp-api'
import { presentDateOrDefault } from '~/modules/ppp/submodules/relations/utils'
import { DataRow, DataHeading } from '~/modules/ppp/submodules/relations/components/data'

type Props = {
  config: DtsInboundSftpDto
}
export const InboundSftp = ({ config }: Props) => (
  <>
    <DataHeading title="SFTP" />
    <DataRow title="createdOn" payload={presentDateOrDefault(config.sftpServer.createdOn)} />
    <DataRow title="host" payload={config.sftpServer.host} withCopy />
    <DataRow title="portNumber" payload={config.sftpServer.portNumber} withCopy />
    <DataRow title="serverName" payload={config.sftpServer.serverName} withCopy />
    <DataRow title="userAuthType" payload={config.sftpServer.userAuthType} />
    <DataRow title="username" payload={config.sftpServer.username} withCopy />
    <DataRow title="path" payload={config.sftpInSettings.path} withCopy />
    <DataRow title="backupDirectory" payload={config.sftpInSettings.backupDirectory} withCopy />
    <DataRow title="backupFileExtension" payload={config.sftpInSettings.backupFileExtension} withCopy />
    <DataRow title="backupFileRetentionDays" payload={config.sftpInSettings.backupFileRetentionDays} />
    <DataRow title="filenameFilter" payload={config.sftpInSettings.filenameFilter} withCopy />
    <DataRow title="minimalFileAge" payload={config.sftpInSettings.minimalFileAge} />
    <DataRow title="scrapeInterval" payload={config.sftpInSettings.scrapeInterval} />
  </>
)
